import Api from 'client/api/v2/Api';

/**
 * @typedef {Object} UserPortalWebAuthnConfig - Configuration for WebAuthn in the User Portal
 * @property {boolean} enabled - Is WebAuthn enabled?
 */
class WebAuthnApi extends Api {
  constructor() {
    super();
    this.userPortalUrl = '/api/userportal/mfa/webauthn';
    this.configUrl = '/api/v2/webauthn/configs';
  }

  /**
   * @returns {UserPortalWebAuthnConfig}
   */
  async getUserPortalConfig() {
    await this.initialize();
    const response = await this.axios.get(this.userPortalUrl);
    return response.data;
  }

  /**
   * @param {UserPortalWebAuthnConfig} config - changes to the WebAuthn User Portal Config
   */
  async updateUserPortalConfig(config) {
    await this.initialize();
    return this.axios.put(this.userPortalUrl, {
      type: 'webauthn',
      enabled: config.enabled,
    });
  }

  async listConfigs() {
    await this.initialize();
    const response = await this.axios.get(this.configUrl);
    return response.data;
  }

  async getConfig(id) {
    await this.initialize();
    const response = await this.axios.get(`${this.configUrl}/${id}`);
    return response.data;
  }

  async putConfig(config) {
    if (config.id == null) {
      throw new Error(`Cannot PUT to organization id: ${config.id}`);
    }
    await this.initialize();
    const response = await this.axios.put(`${this.configUrl}/${config.id}`, { allowSelfRegistration: config.allowSelfRegistration });
    return response.data;
  }
}

export default new WebAuthnApi();
